import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import MONTHS from '../../shared/months.js';
import FormatDollarAmount from './FormatDollarAmount.jsx';
import FormatPercentageValue from './FormatPercentageValue.jsx';
import TieredCell from './TieredCell.jsx';

function MonthlyCommissionRow({ monthCommission }) {
  const isTotal = monthCommission.category === 'Total';

  return (
    <TableRow>
      <TableCell data-cy={`monthly-commissions-product-group-${monthCommission.category}`}>
        {monthCommission.category}
      </TableCell>
      <TableCell
        data-cy={`monthly-commissions-tier1rate-${monthCommission.category}`}
        sx={(theme) => ({ backgroundColor: theme.palette.background.paper })}
      >
        {!isTotal && <FormatPercentageValue value={monthCommission.tier1} />}
      </TableCell>
      <TableCell
        data-cy={`monthly-commissions-tier2rate-${monthCommission.category}`}
        sx={(theme) => ({
          backgroundColor: !isTotal ? 'aqua' : theme.palette.background.paper,
          color: !isTotal ? theme.palette.common.black : undefined,
        })}
      >
        {!isTotal && <FormatPercentageValue value={monthCommission.tier2} />}
      </TableCell>
      <TableCell
        data-cy={`monthly-commissions-tier3rate-${monthCommission.category}`}
        sx={(theme) => ({
          backgroundColor: !isTotal ? 'aquamarine' : theme.palette.background.paper,
          color: !isTotal ? theme.palette.common.black : undefined,
        })}
      >
        {!isTotal && <FormatPercentageValue value={monthCommission.tier3} />}
      </TableCell>
      {MONTHS.map((month) => (
        <TieredCell
          key={month}
          month={month}
          data={monthCommission}
          data-cy={`monthly-commissions-${month}-${monthCommission.category}`}
        />
      ))}
      <TableCell data-cy={`monthly-commissions-total-${monthCommission.category}`}>
        <FormatDollarAmount amount={monthCommission.total} />
      </TableCell>
    </TableRow>
  );
}

MonthlyCommissionRow.propTypes = {
  monthCommission: PropTypes.shape({
    category: PropTypes.string.isRequired,
    tier1: PropTypes.number,
    tier2: PropTypes.number,
    tier3: PropTypes.number,
    total: PropTypes.number.isRequired,
  }).isRequired,
};

export default React.memo(MonthlyCommissionRow);
